import * as firebase from 'firebase';

export const deleteFieldValue = firebase.default.firestore.FieldValue.delete();
export const arrayUnionFieldValue = firebase.default.firestore.FieldValue.arrayUnion;
export const arrayRemoveFieldValue = firebase.default.firestore.FieldValue.arrayRemove;
export const serverTimestamp = firebase.default.firestore.FieldValue.serverTimestamp();

